import { isFunction } from "~/tools/is-function";

import type { CaptureEvents } from "./_capture-events";
import type { CaptureFn } from "./capture-fn";

export type CaptureProp = {
	[TEvent in keyof CaptureEvents]: CaptureEvents[TEvent] extends never
		? CaptureFn<TEvent>
		: [CaptureFn<TEvent, [payload: CaptureEvents[TEvent]]>, CaptureEvents[TEvent]];
}[keyof CaptureEvents];

export function resolveCaptureProp(capture: CaptureProp): void {
	if (isFunction(capture)) {
		capture();
	} else {
		const [fn, arg] = capture as [(arg: unknown) => void, unknown];

		fn(arg);
	}
}
